/**
 * in this module the are all the function to create the invmap popup that include:
 *  - hover popup
 *  - click popup
 */
import Projection from 'ol/proj/Projection'
import pminfo from '../parkmap/pmpopup'
import invinfo from '../invmap/invpopup'
import aminfo from '../accsmap/ampopup'
import functions from './functions'
/**
 * global vars
 */
let pageconfig = JSON.parse($('#pageconfig').val())
let popupconfig = JSON.parse($('#popupconfig').val())
let appname = pageconfig.appname.type
// temporary array for the creation of the hover popup
let hovPopArray = []
let urlstoquery = []
let lang = $('#dropdownLangButton').attr('data-code')
if (lang === '' || lang === null || typeof lang === 'undefined') {lang = 'en'}
// manchester labels confirmed restrictions in the hover popup as Confirmed: instead of Restriction:
let parkmaplayer = functions.altFind(pageconfig.layers, function(e) {return e.layers === "parkmap"})
let restrictionlabel = parkmaplayer && parkmaplayer.popupname === 'manchester' ? popupconfig.hover_popup.confirmed : popupconfig.hover_popup.restriction
let parser = new window.DOMParser()
let allFeatObj
/**
 * infoPopup function
 */

const infoPopup = (view, getOverlay) => {

  let infolayers = _.map(pageconfig.layers, 'wmsfeat')
  /**
   * projection
   */

  const projection = new Projection({
    code: 'EPSG:27700',
    getPointResolution: (r) => {
      return r
    },
    units: 'm'
  })

  /**
   * overlay layer
   */

  let overlay = getOverlay

  /**
   * hover popup container
   */

  let info = $('#info')

  /**
   * close the full info popup when you click on the X symbol
   */

  let closer = document.getElementById('popup-closer')

  /**
   * close the popup and return focus to the map
   */

  const closePopup = () => {
    overlay.setPosition(undefined)
    document.getElementById('map').focus({preventScroll: true})
  }

  closer.onclick = () => {
    closePopup()
    return false
  }

  /**
   * escape closes the popup
   */

  $('#popup').on('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault()
      closePopup()
    }
  })

  /**
   * list items that act as buttons in the popup (feature switcher, documents)
   * can be selected with enter or space
   */

  $('#popup-content, #mobpopupbody').on('keydown', 'li[role="button"]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      $(this).trigger('click')
    }
  })

  /**
   * single click event listener
   */

  view.on('singleclick', function (evt) {
    /**
     * remove the content of the hover popup on click
     */
     evt.preventDefault()
     urlstoquery = []

    info.html('')

    /**
     * check if another button is active
     * return to prevent to show the popup
     */

    if ($('#FraMarker').prop('disabled') === true || $('#Marker').prop('disabled') === true || $('#Polygon').prop('disabled') === true || $('#tlruler').hasClass('removeRuler')) {
      return
    }

    /**
     * define the sendurl to empty
     * define the popup div
     * empty the popup content
     * get the resolution
     * get the coordinate
     * define the layer to query
     */

    var sendurl = ''
    let content = document.getElementById('popup-content')
    content.innerHTML = ''
    const viewResolution = view.getView().getResolution()
    let coordinate = evt.coordinate

    /**
     * get the layers array to query and match just the feat layers
     */
    allFeatObj = parser.parseFromString('<twfeatures></twfeatures>', 'text/xml')
    view.getLayers().getArray().forEach(function (layer) {
      /**
       * this if statement i to exclude the vector layer we use to draw and for the ruler
       */
      if (layer.getSource().getUrls) {
        /**
         * another filter to match just the feat layers and not the map layers(cache layers, ovlayer and layers)
         */

        if (_.intersection(layer.getSource().getUrls(),infolayers).length > 0) {
          sendurl = layer.getSource().getFeatureInfoUrl(coordinate, viewResolution, projection, {
            'INFO_FORMAT': 'text/html',
            'FEATURE_COUNT': '10'
          })

          /**
           * send an ajax request to check if the response is empty or not
           * we need to run it as async false or it will cause problems
           */

          $.ajax({
            url: sendurl,
            async: false
          })
            .done(function (data) {
             // let parser = new window.DOMParser()
              let res = parser.parseFromString(data, 'text/xml')
              let item = res.getElementsByTagName('item')
              /**
               * check the response
               * if it's not empty call the popup function
               */

              if (item.length !== 0) {
                // store number of layers and items to query
                //this will be used to style the popup
                urlstoquery.push(layer.getSource().getUrls()[0])

                for (let i = 0; i < (item.length); i++) {
                  let validItem = item[i].cloneNode(true)
                  if (item[i].attributes.getNamedItem('type').nodeValue !== 'movingSign') {
                    allFeatObj.getElementsByTagName('twfeatures')[0].appendChild(validItem)
                  }
                }

              }
            })
            .fail(function (jqxhr, textStatus, error) {
              const err = `${textStatus}, ${error}`
              console.log(`send URL Request Failed: ${err}`)
            })


        /**
         * end if (layer.getSource().getUrls()...
         * end if (layer.getSource().getUrls) {
         * view.getLayers().getArray().forEach(function (layer) {
         */
        }
      }
    })


    //loop through queried urls to get layer type
    // for popup
    //console.log(urlstoquery)
    let layerinfo = pageconfig.layers

    for (let iurl = 0; iurl < (urlstoquery.length); iurl++) {
      //console.log(urlstoquery[iurl])
      var layertype = layerinfo.filter(obj => {
        return obj.wmsfeat === urlstoquery[iurl]
      })
      //console.log(layertype[0].layers);
      switch (layertype[0].layers) {
        case 'parkmap':
          if (appname === 'consult') {
            pminfo.fullInfoPc(allFeatObj,coordinate, overlay)
          } else {
            pminfo.fullInfo(allFeatObj, coordinate, overlay, view)
          }
        break;
        case 'consult':
          pminfo.fullInfoPc(allFeatObj,coordinate, overlay)
        break;
        case 'accsmap':
          aminfo.fullInfo(allFeatObj, coordinate, overlay)
        break;
        case 'invmap':
          invinfo.fullInfo(allFeatObj,overlay)
        break;
        case 'fra':
          pminfo.fullInfo(allFeatObj, coordinate, overlay)
        case 'psa':
          pminfo.fullInfo(allFeatObj, coordinate, overlay)
        break;
        default:

        }
    }

    /**
     * run the function with a delay to let time to the popup to be rendered
     */

          setTimeout(() => {
          copyEv()
          $('[data-toggle="tooltip"]').tooltip()
        }, 300)
    /**
     * hide the popup if the content is empty
     */

      if ($('#popup-content').html() === '') {
      overlay.setPosition(undefined)
    }
		/**
		 * check the screen size
		 */

     if (functions.mobileTabletView()) {
		  /**
		   * check if the result is no empty
		   * display the modal popup
		   */

		}
		/**
		 * if is a tablet or pc
		 */

		else if (!functions.mobileTabletView()) {
		  /**
		   * check if the result is no empty
		   * display the popup
		   */

		  if (allFeatObj.getElementsByTagName('item').length !== 0) {

			/**
			 * get the coordinate to positioning the popup
			 */

			let coord = view.getView().calculateExtent(view.getSize())

			/**
			 * set the position of the overlay
			 */

			overlay.setPosition(coordinate)

			/**
			 * upper half of the screen
			 */

			if (coordinate[1] > ((coord[1] + coord[3]) / 2)) {
			  /**
			   * apply css style
			   * add correct class
			   */

			  $('#popup').css('bottom', 'auto')
			  $('#popup').css('top', '12px')
			  $('#popup').addClass('ol-poprot')
			  $('#popup').removeClass('ol-pop')
			}
			/**
			 * lower half of the screen
			 */
			else {
			  /**
			   * apply css style
			   * add correct class
			   */

			  $('#popup').css('bottom', '12px')
			  $('#popup').css('top', 'auto')
			  $('#popup').removeClass('ol-poprot')
			  $('#popup').addClass('ol-pop')
			}

			/**
			 * move focus into the popup so screen readers announce it
			 * preventScroll so the map viewport is not scrolled, autoPan handles the positioning
			 */

			document.getElementById('popup').focus({preventScroll: true})

			/**
			 * reset max-height property
			 */

			$('#popup-content').css('max-height', 'none')

			/**
			 * apply max-height property with timeout
			 * to let time at the popup to be rendered
			 * check if popopen === on
			 * click the button to show the list
			 */

			setTimeout(() => {

              let maxHeight = 0
              $('.info-panel').each(function () {

                if ($(this).outerHeight() > maxHeight) {
                    maxHeight = parseInt($(this).outerHeight()) + 50
                }
              })

              let popHeight = `${parseInt($('#popup').outerHeight()) + 50}px`

              if (parseInt($('#popup').outerHeight()) < maxHeight) {
                    popHeight = `${(maxHeight)}px`
              }

			  $('#popup-content').css({'max-height': popHeight, 'overflow-y': 'auto', 'overflow-x': 'hidden'})

			  if (pageconfig.layers[0].popupopen) {
				if ($('#itembutton').length > 0) {
				  $('#itembutton').click()
				}
			  }
			}, 500)
		  }
		  /**
		   * if the result is empty hide the mobile popup
		   */

		  else {
			overlay.setPosition(undefined)
		  }
		} // end else if screen size


  }) // end of single click

  /**
   * pointermove event listener
   */

  /**
   * remove the hover popup if the curson is not on the map
   */

  $(window).on('pointermove', function (evt) {
    let info = $('#info')
    if ($('.ol-mouse-position').text() === '000000.0, 000000.0') {
      info.html('')
    }
  })

  /**
   * pointermove event listener for the hover popup
   */

  let stillMoving = []

  view.on('pointermove', function (evt) {
    /**
     * reset the content of the hover popup
     * reset the content if you are moving the map
     */
    let info = $('#info')
    info.html('')

    if (evt.dragging) {
      info.html('')
      return
    }

    let sendurl = ''
    hovPopArray = []

    /**
     * check if another button is active
     * return to prevent to show the popup
     */

    if ($('#FraMarker').prop('disabled') === true || $('#Marker').prop('disabled') === true || $('#Polygon').prop('disabled') === true || $('#tlruler').hasClass('removeRuler')) {
      return
    }

    /**
     * if the full info popup is in the map reset the content of the hover popup
     */

    if (overlay.getPosition() !== undefined) {
      return
    }

    /**
     * create the hover popup with delay
     */

    $(function () {
      /**
       * add my call to array
       */

      stillMoving.push(true)

      setTimeout(() => {
        /**
         * remove my call to array
         */

        stillMoving.shift()

        /**
         * check if more calls are pending
         * if yes stop propagation
         */

        if (stillMoving[0]) {
          // return
        }
        else {
          /**
           * get the resolution
           * get the coordinate
           * define the layer to query
           */

          let pixel = view.getEventPixel(evt.originalEvent)
          let viewResolution = view.getView().getResolution()
          let coordinate = evt.coordinate

          /**
           * get the layers array to query and match just the feat layers
           */

          view.getLayers().getArray().forEach(function (layer) {
            /**
             * this if statement i to exclude the vector layer we use to draw and for the ruler
             */
            if (layer.getSource().getUrls) {
              /**
               * another filter to match just the feat layers and not the map layers(cache layers, ovlayer and layers)
               */

              if (_.intersection(layer.getSource().getUrls(),infolayers).length > 0) {
                sendurl = layer.getSource().getFeatureInfoUrl(coordinate, viewResolution, projection, {
                  'INFO_FORMAT': 'text/html',
                  'FEATURE_COUNT': '10'
                })

                /**
                 * send an ajax request to check if the response is empty or not
                 * we need to run it as async false or it will cause problems
                 */

                $.ajax({
                  url: sendurl,
                  async: false
                })
                  .done(function (data) {
                    let parser = new window.DOMParser()
                    let res = parser.parseFromString(data, 'text/xml')
                    let item = res.getElementsByTagName('item')

                    /**
                     * check if the result is no empty
                     * display the popup
                     */

                    if (item.length !== 0) {
                      hoverpopup(sendurl, coordinate, pixel)
                    }
                  })
                  .fail(function (jqxhr, textStatus, error) {
                    const err = `${textStatus}, ${error}`
                    console.log(`send URL Request Failed: ${err}`)
                  })

              /**
               * end if (layer.getSource().getUrls()...
               * end if (layer.getSource().getUrls) {
               * view.getLayers().getArray().forEach(function (layer) {
               * end else if !(stillMoving[0])
               * end setTimeout(() => {
               * end $(function () {
               */
              }
            }
          })
        }
      }, 500)
    })

    const hoverpopup = (urls, coordinate, pixel) => {
      /**
       * check if feature and url is not empty
       */

      if (urls) {
        /**
         * send a XMLHttpRequest to the url and get back the xml files compiled
         */

        let xhttp = new XMLHttpRequest()
        xhttp.open('GET', urls, true)
        xhttp.send()
        xhttp.onreadystatechange = function (aEvt) {
          /**
           * check the readyState and status
           */

          if (xhttp.readyState === 4 && xhttp.status === 200) {
            /**
             * get the result from the XML
             * - create a parser
             * - parse the result
             * - get the item element
             */

            let parser = new window.DOMParser()
            let res = parser.parseFromString(xhttp.responseText, 'text/xml')
            let myitems = res.getElementsByTagName('item')

            /**
             * check the length of the result
             */

            if (myitems.length !== 0) {
              /**
               * check the content of the popup
               * if it's empty return
               */

              if (hover(xhttp.responseText) === '') {
                return
              }

              /**
               * get the coordinate to positioning the popup
               */

              let coord = view.getView().calculateExtent(view.getSize())

              /**
               * upper half of the screen
               */

              if (coordinate[1] > ((coord[1] + coord[3]) / 2)) {
                /**
                 * add correct class
                 * create the content of the popup
                 */

                info.html(`<div class='hoverPopup hoverPoprot'>${hover(xhttp.responseText)}</div>`).fadeIn(400)

                /**
                 * set the position of the popup
                 */

                info.css({
                  left: `${pixel[0] + 2}px`,
                  top: `${pixel[1] + $('.hoverPopup').outerHeight() + $('#mainNav').outerHeight() + 20}px`  //95 is the navbar height, 15 a shim
                })
              }
              else {
                /**
                 * add correct class
                 * create the content of the popup
                 */

                // file deepcode ignore DOMXSS: <please specify a reason of ignoring this>
                info.html(`<div class='hoverPopup hoverPop'>${hover(xhttp.responseText)}</div>`).fadeIn(400)

                /**
                 * set the position of the popup
                 */

                info.css({
                  left: `${pixel[0]}px`,
                  top: `${pixel[1] + $('#mainNav').outerHeight()}px`
                })
              }
            }
            /**
             * if myitems.length is 0
             */

            else {
              /**
               * reset the content of the popup
               */

              info.html('')
            }

            /**
             *  end if 4 && 200
             * end onreadystatechange
             * end if(url)
             * end else if (stillMoving[0])
             * end view.on('pointermove', function (evt) {
             * end const infoPopup = (view, getOverlay) => {
             */
          }
        }
      }
    }
  })
}




/**
 * hover popup creation
 */

const hover = (xml) => {
  /**
   * get the result from the XML
   * - create a parser
   * - parse the result
   * - get the item element
   * - get the length of the item element
   */

  let parser = new window.DOMParser()
  let url = parser.parseFromString(xml, 'text/xml')
  let featObj = url
  let myitems = featObj.getElementsByTagName('item')
  let myitemsLength = myitems.length

  /**
   * restriction field for the current language
   */

  const rfield = lang !== 'en' ? 'restriction_ln' : 'restriction'

  /**
   * iterate through the result
   */

  for (let i = 0; i < myitemsLength; i++) {
    const itemtype = myitems[i].attributes.getNamedItem('type').nodeValue

    /**
     * check each type
     * push the correct item in the hovPopArray var
     */

    if (itemtype === 'Confirmed' && appname === 'consult') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.existing} <span class='infotitle_norm'>${myitems[i].getElementsByTagName(rfield)[0].firstChild.nodeValue}</span>`)
    }
    else if (itemtype === 'Confirmed' || itemtype === 'proplayer') {
      /**
       * proposed orders layer is labelled the same way as the full popup
       */

      const label = itemtype === 'proplayer' ? popupconfig.hover_popup.proposed : restrictionlabel
      hovPopArray.push(`<span class='infotitle'>${label} ${functions.getFieldValue(myitems, i, rfield)}</span><br/>`)
    }
    else if (itemtype === 'Proposed') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.proposed} <span class='infotitle_norm'>${myitems[i].getElementsByTagName(rfield)[0].firstChild.nodeValue}</span></span>`)
    }
    else if (itemtype === 'streetlight') {
        if (appname !== 'consult') {
          if (myitems[i].getElementsByTagName('speed')[0].childNodes.length !== 0) {
          hovPopArray.push(`<span class='infotitle'>Area: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('zonename')[0].firstChild.nodeValue}</span></span><span class='infotitle'> Speed: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('speed')[0].firstChild.nodeValue}</span></span>`)
          } else {
            hovPopArray.push(`<span class='infotitle'>Area: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('zonename')[0].firstChild.nodeValue}</span></span><span> Sign</span>`)
          }
        }
    }
    else if (itemtype === 'site') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.site} ${myitems[i].getElementsByTagName('sitename')[0].firstChild.nodeValue}</span><br/>`)
    }
    else if (itemtype === 'accident') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.collision} ${myitems[i].getElementsByTagName('accmonth')[0].firstChild.nodeValue} ${myitems[i].getElementsByTagName('accyear')[0].firstChild.nodeValue} ${myitems[i].getElementsByTagName('severity')[0].firstChild.nodeValue}</span><br/>`)
    }
    else if (itemtype === 'Invmap') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.item} ${myitems[i].getElementsByTagName('inv_type')[0].firstChild.nodeValue}</span><br/>`)
    }
    else if (itemtype === 'Speed') {
      hovPopArray.push(`<span class='infotitle'>${myitems[i].getElementsByTagName('display_group')[0].firstChild.nodeValue}</span>`)
    }
    else if (itemtype === 'Zone Address') {
        if (myitems[i].getElementsByTagName('property')[0].firstChild.nodeValue == 1) {
          hovPopArray.push(`<span class='infotitle'>Non-qualifying Address ${myitems[i].getElementsByTagName('property')[0].firstChild.nodeValue} ${myitems[i].getElementsByTagName('street')[0].firstChild.nodeValue}</span>`)
        } else {
          hovPopArray.push(`<span class='infotitle'>Qualifying Address ${myitems[i].getElementsByTagName('property')[0].firstChild.nodeValue} ${myitems[i].getElementsByTagName('street')[0].firstChild.nodeValue}</span>`)
        }
    }
    else if (itemtype === 'Tariff Zones' || itemtype === 'Parking Zones') {
      hovPopArray.push(`<span class='infotitle'>${myitems[i].getElementsByTagName('polyname')[0].firstChild.nodeValue}</span>`)
    }
    else if (itemtype === 'fra') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.fault} ${myitems[i].getElementsByTagName('fref')[0].firstChild.nodeValue}</span>`)
    }
    else if (itemtype === 'psa') {
      hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.suspension} ${myitems[i].getElementsByTagName('suspid')[0].firstChild.nodeValue}</span>`)
    }
    else if (itemtype === 'route') {
    hovPopArray.push(`<span class='infotitle'>${popupconfig.hover_popup.route} ${myitems[i].getElementsByTagName('name')[0].firstChild.nodeValue}</span>`)
    }



  /**
   * end for (let i = 0; i < myitemsLength; i++) {
   */
  }

  /**
   * as we push every time the previous content we need to filter the final popup
   */

  const removeHoverDuplicates = (arr) => {
    const uniqueArray = []
    for (let x = 0; x < arr.length; x++) {
      if (uniqueArray.indexOf(arr[x]) === -1) {
        uniqueArray.push(arr[x])
      }
    }
    return uniqueArray.join(' ')
  }

  /**
   * return the final hover popup
   */
  return removeHoverDuplicates(hovPopArray)

/**
 * end const hover = (xml) => {
 */
}



/**
 * Copy Event for Popups
 */

 const copyEv = () => {
  let max = ''
  if ($('#numofdivs').length > 0) {
    max = $('#numofdivs').val()
  }
  else {
    max = $('#popup-content').children().length
  }

  for (let i = 0; i < max; i++) {
    if (document.getElementById(`Copy_Btn_${i}`) !== null) {
      document.getElementById(`Copy_Btn_${i}`).addEventListener('click', function () {


        $('.doclisthidden').toggle()
        $('.doclist').toggle()
        $('.url').toggle()
        document.getElementById(`Copy_Btn_${i}`).style.visibility = 'hidden'

        var open = $('#docdiv_'+i).is(':visible')
        $('#docdiv_'+i).show()

        // We will need a range object and a selection.
        let contentHolder = document.getElementById(`info_${i}`)
        // textContent
        // hack for FF, make editable the div
        contentHolder.setAttribute('contenteditable', 'true')
        let range = document.createRange()
        let selection = window.getSelection()

        // Clear selection from any previous data.
        selection.removeAllRanges()

        // Make the range select the entire content of the contentHolder paragraph.
        range.selectNodeContents(contentHolder)

        // Add that range to the selection.
        selection.addRange(range)

        // Copy the selection to clipboard.
        document.execCommand('copy')

        $('.doclisthidden').toggle()
        $('.doclist').toggle()
        $('.url').toggle()
        document.getElementById(`Copy_Btn_${i}`).style.visibility = 'visible'

        if(!open)
        $('#docdiv_'+i).hide()

        // hack for FF, make not editable the div again
        contentHolder.setAttribute('contenteditable', 'false')
        // Clear selection if you want to.
        selection.removeAllRanges()

        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          alert('Firefox has disabled this function')
        }
      })
    } //endif
  } // next
}

/**
 * EXPORT
 */

export default {
  infoPopup
}
